var _ScrollTopService_scrollTopTrigger$;
import { __classPrivateFieldGet } from "tslib";
import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, filter } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/** Registers elements that are scrollable and triggers them when the user wants to scroll up again */
export class ScrollTopService {
    constructor(router) {
        _ScrollTopService_scrollTopTrigger$.set(this, new BehaviorSubject(undefined));
        this.scrollTopTriggered$ = __classPrivateFieldGet(this, _ScrollTopService_scrollTopTrigger$, "f").asObservable();
        // scroll top on navigate
        void router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            this.scrollTop();
        });
    }
    scrollTop() {
        // scroll body first
        window.scrollTo({ top: 0, left: 0 });
        document.body.scrollTop = 0;
        // then trigger all subscribers
        __classPrivateFieldGet(this, _ScrollTopService_scrollTopTrigger$, "f").next();
    }
}
_ScrollTopService_scrollTopTrigger$ = new WeakMap();
ScrollTopService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: ScrollTopService, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
ScrollTopService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: ScrollTopService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: ScrollTopService, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; } });
